'use es6';

import FormattedPercentage from 'I18n/components/FormattedPercentage';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DisplayValuePercentage({
  value
}) {
  return /*#__PURE__*/_jsx(FormattedPercentage, {
    precision: 2,
    stripInsignificantZeros: true,
    value: value * 100
  });
}
DisplayValuePercentage.propTypes = {
  value: PropTypes.number.isRequired
};